export default __webpack_public_path__ + "static/media/FAIRLogo2020-yellow.dce8fd6d.svg";